import ListingStates from '../../../constants/listings/ListingStates'

export const marketAccounts = {
  EBAY: 'ebay_account',
  SHOPIFY: 'shopify_account',
  SHOPGOODWILL: 'shopgoodwill',
  DEPOP: 'depop_account'
}

export const VALID_POLL_STATUSES: string[] = [ListingStates.LISTING.id, ListingStates.MODIFYING.id]

export const TABLE_HEADER_COLUMNS: string[] = ['SKU', 'Status', 'Username']
